import { all, takeEvery, put, select } from 'redux-saga/effects';
import { CancellationTypes, CancellationActions } from './cancellation.redux';
import { selectCancellationBookingId, selectCancellationToken } from './cancellation.selectors';
import { CancellationStatus } from './cancellation.constants';
import { firebaseFunctions } from '../../shared/services/firebase';

function* cancelBooking() {
  const bookingId = yield select(selectCancellationBookingId);
  const token = yield select(selectCancellationToken);
  const functionUrl = ['/emailCustomerCancelBooking', bookingId, token].join('/');

  yield put(CancellationActions.setStatus(CancellationStatus.PENDING));

  try {
    yield firebaseFunctions.get(functionUrl);
    yield put(CancellationActions.setStatus(CancellationStatus.SUCCESS));
  } catch (ex) {
    yield put(CancellationActions.setStatus(CancellationStatus.FAILURE));
  }
}

export default function* cancellationSaga() {
  yield all([takeEvery(CancellationTypes.REQUEST_CANCEL, cancelBooking)]);
}
